// @flow
import React from "react"
import { connect } from "react-redux"

import CommonModalBanner from "../CommonModalBanner/CommonModalBanner"
import Alert from "../Alert/Alert"
import Translate from "../../../../app/scripts/components/Translate"
import translate from "../../../../app/scripts/tools/translate"
import { CONTENT_SITE_TITLES } from "../../../content/consts/content"
import { delayedChatSelector } from "../../services/remoteConfig"
import DelayedChatFooter from "./DelayedChatFooter"
import DelayedChatAlternativeFooter from "./DelayedChatAlternativeFooter"

export type DelayedChatType = {
  alternativeContactText: HTMLElement | string | null,
  alternativeContactLinkText: ?string,
  alternativeContactLinkAddress: string,
  recoverText: HTMLElement | string | null,
  titleText: HTMLElement | string | null,
  titleTextTranslation?: string,
  chatEnabled: boolean,
  showDelayedChat: boolean,
}

// DelayedChat modal is triggered from Exponea
// There will be soon possibility to set also title, recoverTextEl

const FAQ_ARTICLES = [
  {
    val: "What if bad weather leads to my flight being delayed, rescheduled, or cancelled?",
    link: "/helpcenter/article/115", // what-if-bad-weather-leads-to-my-flight-being-delayed-rescheduled-or-cancelled
  },
  {
    val: "Cancellations & Refunds",
    link: "/helpcenter/category/35", // cancellations-&-refunds
  },
  { val: "Baggage", link: "/helpcenter/category/33" }, // baggage
  {
    val: "Manage My Booking FAQ",
    link: "/helpcenter/category/31", // manage-my-booking
  },
  { val: "Boarding pass", link: "/helpcenter/category/37" }, // boarding-pass
]

type Props = {
  onOpenChat: () => void,
  onCloseHandler: () => void,
  delayedChat: DelayedChatType,
}

const DelayedChat = ({
  onOpenChat,
  onCloseHandler,
  delayedChat: {
    alternativeContactText,
    alternativeContactLinkText,
    alternativeContactLinkAddress,
    recoverText,
    titleText,
    titleTextTranslation,
    chatEnabled,
  },
}: Props) => {
  // Open Chat and Close modal
  const handleOpenChat = () => {
    onOpenChat()
    onCloseHandler()
  }

  return (
    <div className="DelayedChat">
      <CommonModalBanner title={translate("common.thanks_for_contacting")} bgType="overloaded" />

      {titleText && (
        <Alert type="error" transparent bordered closable={false}>
          <span dangerouslySetInnerHTML={{ __html: titleText }} />
        </Alert>
      )}

      {titleTextTranslation && (
        <Alert type="error" transparent bordered closable={false}>
          <Translate tKey={titleTextTranslation} />
        </Alert>
      )}

      <div className="DelayedChat-faq">
        <div className="spTypo-subHeader">
          <Translate tKey={CONTENT_SITE_TITLES.faq} />
        </div>

        <ul className="spList _bulleted">
          {FAQ_ARTICLES.map(({ val, link }) => (
            <li key={link}>
              <a href={link} className="spTypoLink" target="_blank" rel="noopener noreferrer">
                {val}
              </a>
            </li>
          ))}
        </ul>
      </div>
      {(recoverText || chatEnabled) && (
        <DelayedChatFooter
          recoverText={recoverText}
          chatEnabled={chatEnabled}
          handleOpenChat={handleOpenChat}
        />
      )}
      {alternativeContactLinkAddress && (
        <DelayedChatAlternativeFooter
          contactText={alternativeContactText}
          contactLinkText={alternativeContactLinkText}
          contactLinkAddress={alternativeContactLinkAddress}
        />
      )}
    </div>
  )
}

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({
  delayedChat: delayedChatSelector(state),
}))(DelayedChat)
